module.exports = __webpack_public_path__ + "static/media/zaguan-tb.06ab5ed2.png";